import { FocusMonitor } from '@angular/cdk/a11y';
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    OnDestroy,
    ViewEncapsulation,
    booleanAttribute,
    inject,
    input,
    model,
} from '@angular/core';

@Component({
    selector: 'ds-pagination-indicator',
    standalone: true,
    template: '<div class="ds-pagination-dot"></div>',
    styleUrl: './pagination-indicator.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'ds-pagination-indicator',
        'role': 'button',
        '[class.ds-pagination-indicator-selected]': 'selected()',
        '[attr.aria-pressed]': 'selected()',
        '[class.ds-pagination-indicator-inverse]': 'inverse()',
        '[attr.tabindex]': '0',
        '[attr.aria-label]': '"Pagination indicator"',
        '(keydown)': 'onKeydown($event)',
    },
})
export class DsPaginationIndicator implements AfterViewInit, OnDestroy {
    private readonly _focusMonitor = inject(FocusMonitor);
    private readonly _elementRef = inject(ElementRef);

    public readonly selected = input(false, { transform: booleanAttribute });
    public readonly inverse = model(false);

    ngAfterViewInit(): void {
        this._focusMonitor.monitor(this._elementRef.nativeElement, true).subscribe((focusOrigin) => {
            if (focusOrigin === 'keyboard' || focusOrigin === 'program') {
                this._elementRef.nativeElement.classList.add('focus-visible');
            } else {
                this._elementRef.nativeElement.classList.remove('focus-visible');
            }
        });
    }

    onKeydown(event: KeyboardEvent): void {
        if (event.code === 'Space' || event.code === 'Enter') {
            event.preventDefault();
            (this._elementRef as ElementRef<HTMLAnchorElement>).nativeElement.click();
        }
    }

    ngOnDestroy(): void {
        this._focusMonitor.stopMonitoring(this._elementRef);
    }
}
